import { createSlice } from '@reduxjs/toolkit'
import { insertTransaction,GetTransaction,insertRequest,GetReceveidRequest } from '../api/NMMBusinessApi'

const initialState = {
    transaction:[],
    TransactionGet :[],
    ReceveidRequest:[],
    loading:false,
}

export const NmmBuisness = createSlice({
  name: 'NmmBuisness',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {

     
      builder.addCase(insertTransaction.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(insertTransaction.fulfilled , (state, action) => {
        console.log(action);
        state.loading = false;
      })
      builder.addCase(insertTransaction.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(GetTransaction.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(GetTransaction.fulfilled , (state, action) => {
       
        state.TransactionGet=action.payload; 
        state.loading = false;
      })
      builder.addCase(GetTransaction.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(insertRequest.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(insertRequest.fulfilled , (state, action) => {
       
        state.TransactionGet=action.payload; 
        state.loading = false;
      })
      builder.addCase(insertRequest.rejected, (state, action) => {
        state.loading = false;
      
      })

      

      builder.addCase(GetReceveidRequest.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(GetReceveidRequest.fulfilled , (state, action) => {
       
        state.ReceveidRequest=action.payload; 
        state.loading = false;
      })
      builder.addCase(GetReceveidRequest.rejected, (state, action) => {
        state.loading = false;
      
      })
    
  },

})



export default NmmBuisness.reducer